import React, { useEffect, useRef } from "react";
import styled from "styled-components";

function SideModal({ show, onClose, children }) {
    const refModal = useRef();

    //click outside to close
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (refModal && refModal.current && !refModal.current.contains(e.target)) {
                // close modal
                // onClose();
            }
        };
        window.addEventListener("click", handleClickOutside);
        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <TotalWrapper>
            <div
                className={`background ${show ? "show" : "d-none"}`}
                onClick={(e) => {
                    onClose();
                }}
            ></div>
            <Wrapper className={`${show ? "show" : "d-none"}`} ref={refModal}>
                <section className="total">{children}</section>
            </Wrapper>
        </TotalWrapper>
    );
}

export default SideModal;

const TotalWrapper = styled.div`
    .background {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: black;
        opacity: 0.4;
    }
`;

const Wrapper = styled.div`
    background: white;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 650px;
    z-index: 999;
    display: flex;
    section.total {
        width: 100%;
    }
`;
